var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-1"},[_c('CRow',[_c('h4',[_vm._v("Olá "),_c('strong',[_vm._v(_vm._s(_vm.userAuth.user))])]),_c('br'),_vm._v(" "+_vm._s(_vm.userAuth)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }